<template>
    <div id="page">
        <div class="page-content" style="padding-bottom:110px!important">
            <div class="page-title page-title-small">
                <h2>
                    <button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>
                    شارژ پیامک اطلاع رسانی
                    <button data-menu="HelpMenu" class="position-static mr-1"><i class="fa fa-question-circle helpIco"></i></button>
                </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="150">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
                <div class="card-bg bg-20"></div>
            </div>

            <div class="card card-style text-center mb-3 pb-3">
                <div class="content pb-2 mb-0">
                    <div>
                        <i class="fa fa-envelope-open-text color-green1-dark fa-3x pt-3 icon-size ml-0"></i>
                    </div>
                </div>
                <p class="px-4 text-justify mb-0 pt-0">
                    هر کاربر در هر دوره اشتراک، دارای تعداد محدودی پیامک اطلاع رسانی می باشد. لطفا برای دریافت پیام های اطلاع رسانی از طریق پیامک حساب کاربری پیامک خود را با انتخاب کاربر و مبلغ مورد نظر شارژ نمایید.
                    <b class="text-danger">در صورتیکه مانده شارژ کاربر منفی باشد اطلاع رسانی ها از طریق پیامک ارسال نمی گردند.</b>
                </p>
                <p class="px-4 text-justify mb-0 pt-0">
                    به دلیل
                    <b class="text-danger">
                        قطعی ارتباط سرویس
                        google play
                    </b>
                    و مقررات وضع شده حاکمیتی، ارسال نوتیفیکیشن درون برنامه ای تا رفع مشکل قطعی سرویس
                    google play
                    مقدور نمی باشد.
                    بدین منظور
                    <b class="text-success">روش اطلاع رسانی اعلانات از طریق پیامک می باشد.</b>
                    در صورت عدم تمایل به ارسال پیامک و پرداخت هزینه شارژ پیامک اطلاع رسانی، می‌توانید با مراجعه به
                    منوی بیشتر »» لیست کاربران، کابر مورد نظر را از لیست انتخاب و در صفحه ویرایش کاربر، تیک ارسال پیامک اطلاع رسانی را بردارید.
                    با برداشتن تیک
                    <b>"ارسال پیامک اطلاع رسانی"</b>
                    (جایگزین نوتیفیکیشن)،
                    <b class="text-warning">هیچگونه اعلانی از طریق پیامک صورت نخواهد گرفت.</b>

                </p>
            </div>


            <div class="card card-style text-center mb-3">
                <div class="content">

                    <!--<div class="mb-3">
                        <v-select dir="rtl" label="title" placeholder="کاربران" :filterable="false" :searchable="false" multiple chips :options="LocalUserListList" :reduce="p => p.userId">
                            <template slot="option">
                                <div class="d-center">
                                    {{ option.title }}
                                </div>
                            </template>
                        </v-select>
                    </div>-->
                    <!--<p class="px-2 text-justify mb-3">
                        لطفا مبلغ شارژ پیامک اطلاع رسانی را مشخص نمایید.
                    </p>-->
                    <!--<div class="mb-3 position-relative">
                        <i class="fa fa-angle-down angle-down-for-select"></i>
                        <select dir="rtl" class="form-control select" id="price">
                            <option value="10000">10,000 تومان</option>
                            <option value="20000">20,000 تومان</option>
                            <option value="50000">50,000 تومان</option>
                            <option value="100000">100,000 تومان</option>
                        </select>-->
                    <!--<v-select dir="rtl" placeholder="مبلغ شارژ" :options="['5.000 تومان' , '10.000 تومان' , '20.000 تومان' , '50.000 تومان']"></v-select>-->
                    <!--</div>-->

                    <p class="px-2 text-justify mb-3">
                        لطفا مبلغ شارژ پیامک اطلاع رسانی را مشخص نمایید.
                    </p>
                    <div class="mb-3">
                        <div class="d-flex">
                            <div class="w-100">
                                <v-select dir="rtl" v-model="price" label="title" placeholder="مبلغ" :options="GetPriceList" :reduce="p => p.price">
                                    <template v-slot="option">
                                        <div class="d-center">
                                            {{ option.title }}
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>
                    <div class="list-group list-custom-small list-icon-0">

                        <div class="list-group-div py-2" v-for="task in LocalUserListList" :key="task.userId">
                            <div class="d-flex align-items-center justify-content-start">
                                <input class="big-checkbox UserSelected" type="checkbox" :value="task.userId" :id="task.userId" :key="task.userId" />
                                <i class="fa fa-user color-red1-light px-3"></i>
                                <b>{{task.title}}</b>
                                <p class="pr-2">
                                    مانده
                                    <b class="text-success ltr d-inline-block" v-if="task.remain>0">{{numberWithCommas(task.remain)}}</b>
                                    <b class="text-danger ltr d-inline-block" v-if="task.remain<0">{{numberWithCommas(task.remain)}}</b>
                                    تومان
                                    <span class="badge bg-red2-dark position-static mt-0" v-if="task.remain<0">نیاز به شارژ</span>
                                </p>
                            </div>

                        </div>
                        <div v-if="Loading" class="d-flex justify-content-center w-100 py-5">
                            <div class="spinner-border color-magenta2-dark" role="status"></div>
                        </div>
                    </div>

                    <a id="result" href="#" target="_blank" style="display:none"></a>


                    <button class="btn btn-xxs mt-2 btn-full bg-green1-dark rounded-sm font-900 w-100" @click="confirmBtn()">
                        <i class="fa fa-check ml-2"></i>
                        تایید
                    </button>
                </div>
            </div>
        </div>
        <Help-Menu title="معرفی موبایل اپلیکیشن تسکینو" keyEn="TaskList"></Help-Menu>
        <!--<div id="smsRechargeHelp" class="menu menu-box-right bg-gray" data-menu-width="100%" data-menu-effect="menu-over">
            <div class="position-relative">
                <button @click="pauseAllVid()" class="close-menu"><i class="fa fa-times text-white font-26"></i></button>
                <div class="card" data-card-height="90">
                    <div class="card-top">
                        <div class="page-title page-title-small">
                            <h2 class="text-center">معرفی موبایل اپلیکیشن تسکینو</h2>
                        </div>
                    </div>
                    <div class="card-overlay bg-highlight opacity-95"></div>
                    <div class="card-overlay dark-mode-tint"></div>

                    <div class="card-bg bg-20"></div>
                </div>
                <div class="card card-style">
                    <div class="content mt-0 pb-2">
                        <div class="list-group list-custom-small list-icon-0 mt-3 border-b">
                            <div data-toggle="collapse" href="#collapse-0" class="collapsed list-group-div" aria-expanded="false">
                                <i class="fa font-14 fa-info-circle color-magenta1-light"></i>
                                <span class="font-14">معرفی موبایل اپلیکیشن تسکینو <span class="badge bg-red2-light mt-0 px-2 py-2 mr-2 position-static">مهم</span></span>
                                <i class="fa fa-angle-down line-height-xl"></i>
                            </div>
                        </div>
                        <div class="collapse border-b pb-3" id="collapse-0" style="">
                            <div class="d-flex justify-content-center">
                                <video class="responsive-video" controls id="video0" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
                                    <source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-SmsRecharge.mp4" type="video/mp4">
                                </video>
                            </div>
                            <a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-SmsRecharge.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>-->
    </div>
    <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
            <div class="modal-content">
                <div class="modal-header d-flex align-items-center">
                    <span class="modal-title font-weight-bold font-16" id="exampleModalLongTitle">پیام</span>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body m-0 pb-0">
                    <div class="my-3" v-html="taskOnlinePayForFreeMessage">

                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-dismiss="modal"><i class="fa fa-times font-10 ml-2"></i>بستن</button>
                </div>
            </div>
        </div>
    </div>
    <!-- Button trigger modal -->
    <button type="button" style="display:none" class="btn btn-primary" id="btnShowModal" data-toggle="modal" data-target="#exampleModalCenter">
        Launch demo modal
    </button>
    <!--<button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center"><i class="font-22 fa fa-bars"></i></button>-->

</template>

<script>
    import VueSimpleAlert from 'vue3-simple-alert';
    import HelpMenu from '../Components/HelpMenu.vue';
    export default {
        components: {
            "Help-Menu": HelpMenu
        },
        data() {
            return {
                page: 1,
                filterId: 0,
                price: null,
                searchKey: "",
                taskOnlinePayForFreeMessage: "",
                selectedTypeId: 0,
                priceList: [],
                pageLoaded: false
            };
        },
        computed: {
            LocalUserListList() {
                let userList = this.$store.getters.GetLocalUserListForSms;
                //if (userList.length === 1)
                //    setTimeout(function () {
                //        document.getElementById(userList[0].userId).checked = true;
                //    }, 500)
                return userList;
            },
            Loading() {
                return this.$store.getters.GetLoading;
            },
            GetPriceList() {
                return this.priceList;
            }
        },

        created() {

            this.$store.dispatch("GetLocalUserListForSMSFromServer", {
                pageId: this.page,
                filterId: this.filterId,
                searchKey: this.searchKey
            }).then(x => {
                this.$http.get("TaskOnline/GetSMSRechargePriceList")
                    .then(data => {
                        this.priceList = data.data;
                    });
            });
            this.$http
                .get("TaskOnline/GetTaskOnlinePayForFreeMessage")
                .then((data) => {
                    this.taskOnlinePayForFreeMessage = data.data;
                });
        },
        methods: {
            numberWithCommas(number) {
                if (number == null || number == "")
                    return "";
                if (number == 0 || number == "0")
                    return "0";

                return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },
            showMenu(userId) {
                this.selectedTypeId = userId;
                document.getElementsByClassName("optionMenu")[0].click();
            },
            filterList() {
                this.page = 1;
                this.$store.dispatch("GetLocalUserListForSMSFromServer", {
                    pageId: this.page,
                    filterId: this.filterId,
                    searchKey: this.searchKey
                });
            },

            getNextPageForLocalUserListList() {
                this.page++;
                this.$store.dispatch("GetLocalUserListForSMSFromServer", {
                    pageId: this.page,
                    filterId: this.filterId,
                    searchKey: this.searchKey
                });
            },

            confirmBtn() {
                if (this.isFreeVersion) {
                    if (this.taskOnlinePayForFreeMessage != null && this.taskOnlinePayForFreeMessage != "") {
                        var btnShowModal = document.getElementById("btnShowModal");
                        btnShowModal?.click();
                        //this.showErrorMessage(this.taskOnlinePayForFreeMessage);
                        return;
                    }
                }

                let checkBox = document.getElementsByClassName("UserSelected");
                let isSelect = false;
                let userIds = [];
                if (this.price == null || this.price == 0) {
                    this.showErrorMessage("مبلغ مورد نظر برای شارژ پیامکی را انتخاب کنید");
                }
                if (checkBox.length <= 0) {
                    this.showErrorMessage("لطفا کاربران مورد نظر جهت شارژ SMS را انتخاب نمایید.");
                } else {
                    for (var i = 0; i < checkBox.length; i++) {
                        if (checkBox[i].checked) {
                            isSelect = true;
                            userIds.push(checkBox[i].value);
                        }
                    }
                    if (isSelect) {
                        if (userIds.length > 2 && (userIds.length % 2) > 0) {
                            this.showErrorMessage('تعداد کاربر انتخابی میبایست زوج باشد');
                        } else {
                            let strUserIds = userIds.join(",");
                            let price = this.price;
                            this.$http.get("Person/SmsRecharge?userIds=" + strUserIds + "&price=" + price)
                                .then(data => {
                                    if (data.data == null || data.data == "") {
                                        this.showErrorMessage('خطایی در روند انتقال به درگاه به وجود آمده است.لطفا مجددا تلاش نمایید');
                                    } else {
                                        document.getElementById("result").setAttribute('href', data.data);
                                        document.getElementById("result").click();
                                    }
                                });
                        }
                    } else {
                        this.showErrorMessage('لطفا کاربران مورد نظر جهت شارژ SMS را انتخاب نمایید.');
                    }
                }
                //if (checkBox.checked == true) {
                //	VueSimpleAlert.fire({
                //                    title: 'کاربران 229 انتخاب شده اند. آیا ادامه می دهید؟',
                //		showCancelButton: true,
                //		confirmButtonText: 'تأیید',
                //		cancelButtonText: `انصراف`,
                //	})
                //} else {
                //	VueSimpleAlert.fire({
                //		title: 'لطفا کاربران مورد نظر جهت شارژ SMS را انتخاب نمایید.',
                //		showCancelButton: true,
                //		confirmButtonText: 'تأیید',
                //		cancelButtonText: `انصراف`,
                //	})
                //}



            },
            pauseAllVid() {
                document.querySelectorAll('video').forEach(vid => vid.pause());
            },
        },
        mounted() {
            document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");

            console.log("mounted");
            this.getNextPageForLocalUserListList();

        }
    };
</script>
